// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v5.4.19-2-g879fd7e9c81f5263bce4c8d03fc952a9e01d4e40",
    "hash": "g879fd7e9c81f5263bce4c8d03fc952a9e01d4e40",
    "distance": 2,
    "tag": "v5.4.19",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v5.4.19",
        "major": 5,
        "minor": 4,
        "patch": 19,
        "prerelease": [],
        "build": [],
        "version": "5.4.19"
    },
    "suffix": "2-g879fd7e9c81f5263bce4c8d03fc952a9e01d4e40",
    "semverString": "5.4.19+2.g879fd7e9c81f5263bce4c8d03fc952a9e01d4e40",
    "version": "5.4.19"
};
/* tslint:enable */
